<template>
  <div ref="canvasWrapper" class="relative" :data-page-number="pageNumber">
    <canvas ref="canvas" class="absolute left-0 top-0 origin-top-left" />
    <div ref="textLayer" class="absolute left-0 top-0 origin-top-left" />
  </div>
</template>

<script setup>
import { computed, inject, ref } from "vue"

import { useSetupDocumentPage } from "../../composables/pdf-viewer/setupDocumentPage"

const props = defineProps(["pageNumber", "isPresenting", "getTextContentCanvasContext", "getTextContentAscent"])

const isPresenting = computed(() => props.isPresenting)

const canvasWrapper = ref(null)
const canvas = ref(null)
const textLayer = ref(null)

const pdfDocument = inject("PDF_DOCUMENT")
const keyboardState = inject("KEYBOARD_STATE")
const containerState = inject("CONTAINER_STATE")
const pagingState = inject("PAGING_STATE")
const currentPageState = inject("CURRENT_PAGE_STATE")
const scalingState = inject("SCALING_STATE")

useSetupDocumentPage({
  pageNumber: props.pageNumber,
  isPresenting,
  getTextContentCanvasContext: props.getTextContentCanvasContext,
  getTextContentAscent: props.getTextContentAscent,
  pdfDocument,
  keyboardState,
  containerState,
  pagingState,
  currentPageState,
  scalingState,
  canvasWrapper,
  canvas,
  textLayer
})
</script>
